import React from 'react';
import { Button } from 'react-bootstrap';

const AirCompressorsNavBar = ({ onLaneChange, activeLane }) => {
  const lanes = ['ALL'];

  return (
    <div className="nav-links">
      <div className="nav-links-inner">
        {lanes.map(lane => (
          <Button
            key={lane}
            variant={activeLane === lane ? 'primary' : 'outline-secondary'}
            className={`nav-link ${activeLane === lane ? 'active' : ''}`}
            onClick={() => onLaneChange(lane)}
          >
            {lane}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default AirCompressorsNavBar;
